export const UPDATE_AUTH = (state, auth) => {
    state.auth = auth
}

export const UPDATE_USER = (state, user) => {
    state.user = user
}

export const UPDATE_USER_AVATAR = (state, avatarUrl) => {
    state.user.avatarUrl = avatarUrl
}

/**
 * Clear each property, one by one, so reactivity still works.
 *
 * (ie. clear out state.auth.isLoggedIn so Navbar component automatically reacts to logged out state,
 * and the Navbar menu adjusts accordingly)
 *
 * TODO: use a common import of default state to reset these values with.
 */
export const CLEAR_ALL_DATA = (state) => {
    // Auth
    state.auth.isLoggedIn = false
    state.auth.accessToken = null
    state.auth.refreshToken = null


    // User
    state.user.userId = ''
    state.user.userName = ''
    state.user.nickName = ''
    state.user.loginType = ''
    state.user.departName = ''
    state.user.departId = ''
    state.user.avatarUrl = ''
    state.user.userType = ''
    state.user.roles = null
}

export const UPDATE_TABLE_HEIGHT = (state, tableHeight) => {
    state.tableHeight = tableHeight;
}

export const UPDATE_PAGE_BACKGROUND = (state, pageBackground) => {
    state.pageBackground = pageBackground;
}

export const UPDATE_NAV_COLLAPSE = (state, navCollapsed) => {
    state.navCollapsed = navCollapsed;
}

export const UPDATE_SEARCH_VALUE = (state, searchValue) => {
    state.searchValue = searchValue;
}



// WEBPACK FOOTER //
// ./src/store/mutations.js